class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.setSplideOptions();
    this.productGallery = ".js-data-product";
    this.productThumbnails = ".js-data-product--thumbnails";
    
    /**DY Image Gallery test 4/23 **/
    this.segment = 'v0_control';
    if (window.Marlow?.image_gallery?.new_default_image_position){
      this.addDYImages();
      this.segment = window.Marlow?.image_gallery?.new_default_image_position == "1" ? 'v1_main_image' : 'v2_alt_image';
    }
    this.init();
    this.initHeapCustomEvents();
  }
  addDYImages = () => {
    const imgPosition = parseInt(window.Marlow?.image_gallery?.new_default_image_position);
    let newThumbnailHTML = this.querySelector(".dy--image-gallery-thumbnails").innerHTML;
    let newImageHTML = this.querySelector(".dy--image-gallery-images").innerHTML;
    const thumbnailContainer = this.querySelector('.js-data-product--thumbnails .splide__list');
    const imageContainer = this.querySelector('.js-data-product .splide__list');
    let thumbnails = this.querySelectorAll(".js-data-product--thumbnails .splide__slide");
    let images = this.querySelectorAll(".js-data-product .splide__slide");
    thumbnailContainer.innerHTML = '';
    imageContainer.innerHTML = '';
    let swappedImage = '';

    thumbnails.forEach((thumbnail, index) => {
      if(index == imgPosition - 1){
        thumbnailContainer.innerHTML += newThumbnailHTML;
        imageContainer.innerHTML += newImageHTML;
        swappedImage = index;
        thumbnailContainer.innerHTML += thumbnails[swappedImage].outerHTML;
        imageContainer.innerHTML += images[swappedImage].outerHTML;
        this.querySelector(".dy--image-gallery-container").remove();
       } else {
        thumbnailContainer.innerHTML += thumbnail.outerHTML;
        imageContainer.innerHTML += images[index].outerHTML;
       } 
    })
    
  }
  initHeapCustomEvents = () => {
    const dyElements = this.querySelectorAll('[data-ht-element]');
    dyElements.forEach(el => {
      el.addEventListener('click', () => {
        this.fireHeapEvent("DY Image Gallery - Click", {
          "DY Image Gallery Campaign": "pdp_image_gallery_test_04_23",
          "DY Image Gallery Segment": this.segment,
          "DY Image Gallery Element": el.getAttribute("data-ht-element"),
        });
      })
    })
  }
  setSplideOptions = () => {
    this.productGalleryOptions = {
      type: "loop",
      pagination: false,
      drag: false,
      gap:1
    };
    this.productThumbnailOptions = {
      fixedWidth: 60,
      fixedHeight: 60,
      gap: 6,
      perPage: 6,
      pagination: false,
      isNavigation: true,
      arrows: false,
      breakpoints: {
        900: {
          fixedWidth: 50,
          fixedHeight: 50,
        },
        749: {
          fixedWidth: 40,
          fixedHeight: 40,
        },
      },
    };
  };
  init = () => {
    this.gallery = new Splide(this.productGallery, this.productGalleryOptions);
    this.thumbnails = new Splide(this.productThumbnails, this.productThumbnailOptions);
    this.gallery.sync(this.thumbnails);
    this.gallery.mount();
    this.thumbnails.mount();
    this.initCustomDrag();
  };
  initCustomDrag() {
    /*
        Custom drag functionality based off of previous QA sessions, where flicking / dragging the gallery would jump the slide index more than one. OOTB options such as flickPower, flickMaxPages, dragMinThreshold, are not 100% foolproof
        - disables native drag functionality
        - instead, uses mousedown and mouseup event listeners to determine a "swipe" or a "drag" on the gallery element, in either the left or right direction
        - fires a slide change when a left swipe or right swipe is detected  
        */
    const galleryComponent = this.gallery.Components;
    let initialXPos, finalXPos, initialYPos;
    let context = this;
    this.querySelectorAll(".splide__slide").forEach((slide) => {
      slide.addEventListener("mousedown", function (e) {
        initialXPos = e.clientX;
        initialYPos = e.clientY;
        context.isActive = true;
      });
      slide.addEventListener("touchstart", function (e) {
        initialXPos = e.changedTouches[0].clientX;
        initialYPos = e.changedTouches[0].clientY;
      });
      slide.addEventListener("touchend", (e) => {
        /* prevent a slide change if:
              a) there's barely any difference between the initial and final swipe positions (75px)
              b) user didn't fire a touchstart event on the gallery to begin with
              c) user intended to swipe vertically to scroll instead of swiping horizontally (75px)
              */
        if (initialXPos && Math.abs(initialXPos - e.changedTouches[0].clientX) > 75 && Math.abs(initialYPos - e.changedTouches[0].clientY) < 75) {
          this.fireHeapEvent("DY Image Gallery - Swipe", { "DY Image Gallery Campaign": "pdp_image_gallery_test_04_23", "DY Image Gallery Segment": this.segment, "DY Image Gallery Element": "image" });
          finalXPos = e.changedTouches[0].clientX;
          finalXPos > initialXPos ? galleryComponent.Controller.go("-1") : galleryComponent.Controller.go("+1");
          initialXPos = false;
        }
      });
    });
    document.addEventListener("mouseup", (e) => {
      //add event listener to the document instead of the gallery element in case the user lifts their mouse up past the gallery image
      if (initialXPos && Math.abs(initialXPos - e.clientX) > 20 && context.isActive) {
              this.fireHeapEvent("DY Image Gallery - Swipe", {
                "DY Image Gallery Campaign": "pdp_image_gallery_test_04_23",
                "DY Image Gallery Segment": this.segment,
                "DY Image Gallery Element": "image"
              });
        finalXPos = e.clientX;
        //edge case check: makes sure slide change doesn't fire when the mobile zoom overlay is active
        if (e.clientY > 56) finalXPos > initialXPos ? galleryComponent.Controller.go("-1") : galleryComponent.Controller.go("+1");
        initialXPos = false;
        context.isActive = false;
      } else if (context.isActive) {
        context.isActive = false;
      }
    });
  }
  fireHeapEvent(event, props) {
    heap.track(`${event}`, props || {});
  }
}

customElements.define('product-gallery', ProductGallery);